import { motion } from "framer-motion";
import BgOrnaments from "@/components/vu/BgOrnaments";

const works = [
    { client: "SSC", tag: "BRAND · SHOPIFY · EMAIL", stat: "+3.4× revenue in 90 days", img: "/images/ssc-safety-security.png", link: "https://saenzsc.net/" },
    { client: "MJC General Contractors", tag: "SITE · META ADS", stat: "6.8× ROAS · Q3", img: "/images/mjc.png", link: "https://mjcgeneralcontractors.com/" }
];

export default function WorkGallery() {
    return (
        <section id="work" data-testid="work-gallery" className="relative py-[110px] md:py-[130px] border-t border-[#1F3A2B] overflow-hidden">
            <BgOrnaments variant="dots" />
            <div className="max-w-[1240px] mx-auto px-8">
                <div className="grid md:grid-cols-12 gap-6 mb-14">
                    <div className="md:col-span-4">
                        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 border border-[#2A4A38] bg-[#152A20]/60 backdrop-blur rounded-full text-[11.5px] text-[#A6BDB0] mb-5">
                            <span className="w-[7px] h-[7px] rounded-full bg-[#DFFF3D]" /> Selected Work
                        </div>
                    </div>
                    <div className="md:col-span-8">
                        <h2 className="font-display text-white tracking-tight leading-[1.02]" style={{ fontSize: "clamp(2.4rem, 4.4vw, 3.4rem)" }}>
                            Real brands.<br />
                            <span className="italic-serif text-[#DFFF3D]">Real numbers.</span>
                        </h2>
                        <p className="mt-5 text-[15.5px] text-[#A6BDB0] max-w-[540px]">A snapshot of local businesses we're actively growing. Every screenshot below is a live retainer client.</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-5 auto-rows-[220px] sm:auto-rows-[260px] md:auto-rows-[340px]">
                    {works.map((w, i) => {
                        // Bento sizing: 0=lg, 1=sm, 2=sm, 3=lg
                        const span = i === 0 || i === 3 ? "lg:col-span-7" : "lg:col-span-5";
                        return (
                            <motion.a
                                href={w.link || "#contact"}
                                target={w.link ? "_blank" : undefined}
                                rel={w.link ? "noopener noreferrer" : undefined}
                                onClick={w.link ? undefined : (e) => {
                                    e.preventDefault();
                                    const el = document.querySelector("#contact");
                                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                                }}
                                key={w.client}
                                data-testid={`work-card-${i}`}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-10%" }}
                                transition={{ duration: 0.7, delay: i * 0.08 }}
                                className={`group relative rounded-[24px] overflow-hidden card-shadow card-shadow-hover tilt-lift will-change-transform ${span}`}
                            >
                                <img src={w.img} alt={w.client} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.06]" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0E1F16] via-[#0E1F16]/30 to-transparent" />
                                <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 400px 260px at 30% 100%, rgba(223,255,61,0.14), transparent 60%)" }} />

                                <div className="relative h-full p-7 flex flex-col justify-between">
                                    <div className="flex items-start justify-between">
                                        <span className="mono text-[10px] text-white/80 bg-white/10 backdrop-blur px-2.5 py-1 rounded-full border border-white/20">CS · 0{i + 1}</span>
                                        <div className="w-9 h-9 rounded-full border border-white/25 bg-white/10 backdrop-blur flex items-center justify-center text-white group-hover:bg-[#DFFF3D] group-hover:text-[#0E1F16] group-hover:border-[#DFFF3D] transition-all">
                                            <i className="fa-solid fa-arrow-right text-xs" />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="mono text-[10px] text-[#DFFF3D] mb-2 flex items-center gap-2">
                                            <span className="w-1.5 h-1.5 rounded-full bg-[#DFFF3D]" /> {w.tag}
                                        </div>
                                        <h3 className="font-display text-white text-[26px] md:text-[30px] tracking-tight leading-tight">{w.client}</h3>
                                        <div className="mt-2 text-white/85 text-[14px] flex items-center gap-2">
                                            <i className="fa-solid fa-arrow-trend-up text-[#DFFF3D]" /> {w.stat}
                                        </div>
                                    </div>
                                </div>
                            </motion.a>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
